import { useDocFlowHandleFinish } from '../../DocFlow.hooks'
import { DocFlowProfileHeaderActionsBase } from '../DocFlowProfileHeaderActionsBase'

function DocFlowProfileHeaderActionsSending({ onReloadProcess, ...restProps }) {
  const { handleNextPhase } = useDocFlowHandleFinish({ onReloadProcess })

  return (
    <DocFlowProfileHeaderActionsBase
      {...restProps}
      onNextPhase={handleNextPhase}
    />
  )
}

export default DocFlowProfileHeaderActionsSending
